<span
  class="origin"
  cdkOverlayOrigin
  #iconPickerOrigin="cdkOverlayOrigin"
></span>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="iconPickerOrigin"
  [cdkConnectedOverlayOpen]="true"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="20"
  [cdkConnectedOverlayPositions]="overlayPositions"
>
  <div
    class="icon-picker"
  >
    <motn-icon-picker
      [icon]="icon"
      (iconPicked$)="onClick($event)"
    ></motn-icon-picker>
  </div>
</ng-template>
